// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t8jOj","icon":"styles_icon__3SyX9"};